<template>
    <div class="user-list">
        <h3>现金交易管理</h3>
        <el-form :inline="true" class="demo-form-inline" v-loading="loading" size="mini">
            <el-form-item>
                <el-input v-model="filter.recordOrderId" placeholder="输入单号查询" ></el-input>
            </el-form-item>
            <el-form-item label="业务类型">
                <el-select v-model="filter.business">

                    <el-option label="全部" value=""></el-option>
                    <el-option label="购买线索卡" value="cule"></el-option>
                    <el-option label="购买服务" value="order"></el-option>
                    <el-option label="申请提现" value="withdraw"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="支付方式">
                <el-select v-model="filter.payWay">

                    <el-option label="全部" value=""></el-option>
                    <el-option label="余额" value="balance"></el-option>
                    <el-option label="微信" value="wx"></el-option>
                    <el-option label="商户平台" value="system"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="支付状态">
                <el-select v-model="filter.status">

                    <el-option label="全部" value=""></el-option>
                    <el-option label="支付成功" value="succ"></el-option>
                    <el-option label="支付失败" value="fail"></el-option>
                    <el-option label="申请成功" value="submit"></el-option>
                    <el-option label="待打款" value="wait"></el-option>
                    <el-option label="已打款" value="yes"></el-option>
                    <el-option label="驳回申请" value="reject"></el-option>
                </el-select>
            </el-form-item>

            <el-form-item label="开始时间">
                <el-date-picker
                        v-model="filter.startTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        align="center"
                >
                </el-date-picker>
            </el-form-item>

            <el-form-item label="结束时间">
                <el-date-picker
                        v-model="filter.endTime"
                        type="datetime"
                        placeholder="选择日期时间"
                        align="center"
                >
                </el-date-picker>
            </el-form-item>
            <el-form-item>
                <el-button @click="search">搜索</el-button>
            </el-form-item>
            <!--<el-form-item>-->
                <!--<el-button @click="download">导出</el-button>-->
            <!--</el-form-item>-->
        </el-form>


        <el-table :data="list" size="mini">
            <!--<el-table-column type="expand">-->
                <!--<template slot-scope="props">-->
                   <!--dsds-->
                <!--</template>-->
            <!--</el-table-column>-->
            <el-table-column prop="recordOrderId" label="ID" ></el-table-column>
            <el-table-column label="业务类型" >
                <template slot-scope="scope">

                    <span v-if="scope.row.business==='cule'">购买线索卡</span>
                    <span v-if="scope.row.business==='order'">购买服务</span>
                    <span v-if="scope.row.business==='withdraw'">申请提现</span>

                </template>
            </el-table-column>
            <el-table-column prop="payWay" label="支付方式">
                <template slot-scope="scope">
                    <p v-if="scope.row.payWay === 'wx'">微信</p>
                    <p v-if="scope.row.payWay === 'balance'">余额</p>
                    <p v-if="scope.row.payWay === 'system'">商户平台</p>
                </template>
            </el-table-column>
            <el-table-column label="支付金额">
                <template slot-scope="scope">
                    {{scope.row.amount/100}}元
                </template>
            </el-table-column>
            <el-table-column prop="userAName" label="甲方">
                <template slot-scope="scope">
                    <p v-if="scope.row.userAName==='system'">商户平台</p>
                    <p v-else>{{scope.row.userAName}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="支付状态">
                <template slot-scope="scope">
                    <p v-if="scope.row.status === 'succ'">支付成功</p>
                    <p v-if="scope.row.status === 'fail'">支付失败</p>
                    <p v-if="scope.row.status === 'submit'">申请成功</p>
                    <p v-if="scope.row.status === 'wait'">待打款</p>
                    <p v-if="scope.row.status === 'yes'">已打款</p>
                    <p v-if="scope.row.status === 'reject'">驳回申请</p>
                </template>
            </el-table-column>
            <el-table-column prop="userBName" label="乙方">
                <template slot-scope="scope">
                    <p v-if="scope.row.userBName==='system'">商户平台</p>
                    <p v-else>{{scope.row.userBName}}</p>
                </template>
            </el-table-column>
            <el-table-column prop="status" label="收款状态">
                <template slot-scope="scope">
                    <p v-if="scope.row.status === 'succ'">收款成功</p>
                    <p v-if="scope.row.status === 'fail'">收款失败</p>
                    <p v-if="scope.row.status === 'submit'">待审核</p>
                    <p v-if="scope.row.status === 'wait'">申请成功</p>
                    <p v-if="scope.row.status === 'yes'">收款成功</p>
                    <p v-if="scope.row.status === 'reject'">申请失败</p>
                </template>
            </el-table-column>
            <el-table-column prop="updateTime" label="时间"></el-table-column>
        </el-table>
        <br/>
        <div style="float: right">
            <el-pagination
                    background
                    layout="prev, pager, next"
                    @current-change="i=>page=i"
                    :page-size="20"
                    :page-count="page"
                    :total="total"
                    ref="pagination"
            >
            </el-pagination>
        </div>
    <a id="d"></a>
    </div>
</template>

<script>
    import moment from 'moment'
    import CSV from 'comma-separated-values'
  import api from '../api'
  const {trade} = api



  export default {
    name: "user-list",
    data() {
      return {
        loading: true,

        list: [],
        roles:[],
        total:0,
        page:1,
        filter:{
          recordOrderId:'',
          startTime:"",
          endTime:'',
          business:'',
          payWay:'',
          status:''
        }
      };
    },
    watch:{
      page(){
        this.fetch()
      }
    },
    methods: {
      download(){


	      let csvRows = this.list.map(item=>{
	      	return Object.values(item).join(',')
          })
	      var csvString = csvRows.join('\n');

	      var BOM = '\uFEFF';
	      csvString = BOM + csvString;

	      var a = document.getElementById('d');
	      a.href = 'data:text/csv;charset=utf-8,\ufeff' + encodeURI(csvString);
	      a.target = '_blank';
	      a.download = 'sucaihuo.csv';
	      a.click()
      },
      async fetch() {
        let pageNum = this.page
        this.loading = true;

        let {recordOrderId,startTime,endTime,business,payWay,status} = this.filter
        let obj = {start:(pageNum-1)*20,recordOrderId,startTime,endTime,business,payWay,status}
	      if(obj.startTime && obj.endTime){
		      obj.startTime = Date.parse(obj.startTime)
		      obj.endTime = Date.parse(obj.endTime)
	      }
        if (startTime && !endTime) {
          obj.endTime = Date.now()
          obj.startTime = Date.parse(obj.startTime)
        }
        let res = await trade.list(obj);
        this.list = res.data.data;
        this.loading = false;
        this.total = res.data.pageinfo.totalCount
      },
      async search () {
        this.$refs.pagination.internalCurrentPage = 1
        this.page = 1
        this.fetch()
      }
    },
    mounted() {
      this.fetch();
    }
  };
</script>

<style>
    .user-list {
    }
</style>



// WEBPACK FOOTER //
// src/views/order/trade.vue